const { Core, Utils } = Global;
const { $state } = Utils;

function isPositiveInteger(value)   {
    return Number.isInteger(value) && value > 0;
}

customElements.define('product-qty-input', class extends Core {
    elements = {
        $: ['button-minus', 'button-plus', 'input']
    }

   

    render() {

         this.currentValue = +this.$('input').value;
         this.minValue = +this.$('input').getAttribute('min');
         this.step = +this.$('input').getAttribute('step');
      
        this.$('button-plus', { click: this._changeBy(this.step) });
        this.$('button-minus', { click: this._changeBy(this.step * -1) });
       // this.$('input', { change: this._handleChange });
        this.querySelector("input").addEventListener("change",() => {
          this._handleChangeInput(this.$('input'));
        })
        
    }

    _changeBy(value) {  
        return () => {
            this.currentValue += value;
            this._applyCurrentValue();
            this._handleChangeInput(this.$('input'));
        }
    }

    _handleChange({ target }) {
     //  console.log("here");
        const value = target.valueAsNumber;
        if (this.qtyLimit && value > this.qtyLimit) {
            this.currentValue = this.qtyLimit;
        } else if (!isPositiveInteger(value)) {
            this.currentValue = this.minValue;
        } else {
            this.currentValue = value;
        }
        this._applyCurrentValue();
    }

    _handleChangeInput(input) {
       //console.log("here2");
        const value = input.valueAsNumber;
        if (this.qtyLimit && value > this.qtyLimit) {
            this.currentValue = this.qtyLimit;
        } else if (!isPositiveInteger(value)) {
            this.currentValue = this.minValue;
        } else if (value < this.minValue) {
            this.currentValue = this.minValue;
        }else if (value % this.step != 0) {
            this.currentValue = Math.ceil(value/this.step) * this.step;
        }else {
            this.currentValue = value;
        }
        this._applyCurrentValue();
    }

    _applyCurrentValue() {
        this.$('input').value = this.currentValue;
        this._toggleButtons();
    }
    
    _toggleButtons() {
        this.$('button-minus').toggleAttribute('disabled', this.currentValue === this.minValue);
        this.$('button-plus').toggleAttribute('disabled', this.currentValue === this.qtyLimit);
    }

    get qtyLimit() {
        return 9999;
        //return +this.$('input').getAttribute('max');
    }
})